import { IMdc, IMdcSendOneResponse, MdcIpAddressType } from './IMdc';

export default class NotImplementedMdc implements IMdc {
	public async sendOne(_ipAddress: MdcIpAddressType, _command: number, _data: number[] | []): Promise<IMdcSendOneResponse> {
		throw Error('MDC is not implemented.');
	}
	public async sendOneRaw(_ipAddress: MdcIpAddressType, _command: []): Promise<IMdcSendOneResponse> {
		throw Error('MDC is not implemented.');
	}
}
